import styled from "styled-components";

export const Layout = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;

export const BlockWhite = styled("div")``;
